import React from 'react';
import styled, { css } from 'styled-components';
import { Box, Flex } from 'rebass/styled-components';
import { LoadingSkeleton as Skeleton } from 'components/core/loading-skeletons';
import { Section } from 'src/payments/instore-cart/views/instore-cart/instore-cart';

export const CartLoader = (): JSX.Element => <CartSkeletons />;

const CartSkeletons = (): JSX.Element => (
  <Box width='100%' data-testid='cart-loader'>
    <Section showBorder={false}>
      <ItemSkeleton />
      <ItemSkeleton />
      <ItemSkeleton />
    </Section>
    <Section>
      <Flex justifyContent='space-between'>
        <Skeleton width={68} height={12} />
        <Skeleton width={36} height={12} />
      </Flex>
      <Skeleton height={36} />
    </Section>
    <Section>
      <Flex justifyContent='space-between' marginBottom='2px'>
        <Skeleton width={36} height={12} />
        <Skeleton width={36} height={12} />
      </Flex>
      <Flex justifyContent='space-between' marginBottom='2px'>
        <Skeleton width={36} height={12} />
        <Skeleton width={36} height={12} />
      </Flex>
      <Flex justifyContent='space-between' marginBottom='-6px'>
        <Skeleton width={36} height={12} />
        <Skeleton width={36} height={12} />
      </Flex>
    </Section>
    <Section>
      <Skeleton width={68} height={12} />
      <Flex>
        <Skeleton width={12} height={12} mr='6px' />
        <Skeleton width={68} height={12} />
      </Flex>
    </Section>
    <Section>
      <SkeletonButton height={40} />
    </Section>
  </Box>
);

const ItemSkeleton = (): JSX.Element => (
  <Item>
    <div>
      <Skeleton width={44} height={12} />
      <Skeleton width={137} height={12} />
      <Skeleton width={25} height={12} />
    </div>
    <div>
      <Skeleton width={36} height={12} />
    </div>
  </Item>
);

const Item = styled.div`
  ${({ theme: { spaces } }) => css`
    display: grid;
    grid-template-columns: 1fr ${spaces[9]};
    grid-gap: ${spaces[2]};
    align-items: center;
    width: 100%;
    margin-bottom: ${spaces[3]};

    &:last-of-type {
      margin-bottom: 0;
    }
  `}
`;

const SkeletonButton = styled(Skeleton)`
  border-radius: var(--dct--customized-radius-buttons);
`;
